module.exports = __webpack_public_path__ + "img/LK.04b20662.svg";